import { AI_ASSIST, type AiAssistStateType, aiAssistReducer } from "./aiAssist";
import {
	BUNDLED_PLAYLIST_GRAPHIC,
	type BundledPlaylistGraphicStateType,
	bundledPlaylistGraphicReducer,
} from "./bundledPlaylistGraphic";
import { CANVAS, type CanvasStateType, canvasReducer } from "./canvas";
import { CONTROL, type ControlStateType, controlReducer } from "./control";
import {
	DATA_PROVIDER_TRANSLATION,
	type DataProviderTranslationStateType,
	dataProviderTranslationReducer,
} from "./dataProviderTranslation";
import { GRAPHIC, type GraphicStateType, graphicReducer } from "./graphic";
import {
	GRAPHIC_PACKAGE,
	type GraphicPackageStateType,
	graphicPackageReducer,
} from "./graphicPackage";
import { MATCH_CONTROLS, type MatchControlsStateType, matchControlsReducer } from "./matchControls";
import { MEDIA_LIBRARY, type MediaLibraryStateType, mediaLibraryReducer } from "./mediaLibrary";
import { MOS, type MosStateType, mosReducer } from "./mos";
import { NOTIFICATION, type NotificationStateType, notificationReducer } from "./notification";
import { OUTPUT, type OutputStateType, outputReducer } from "./output";
import { PLAYLIST, type PlaylistStateType, playlistReducer } from "./playlist";
import {
	PLAYLIST_GRAPHIC,
	type PlaylistGraphicStateType,
	playlistGraphicReducer,
} from "./playlistGraphic";
import { RUNDOWN, type RundownStateType, rundownReducer } from "./rundown";
import {
	RUNDOWN_TEMPLATE,
	type RundownTemplateStateType,
	rundownTemplateReducer,
} from "./rundownTemplate";
import { SPORT_DATA, type SportDataStateType, sportDataReducer } from "./sportData";
import { UI, type UIStateType, uiReducer } from "./ui";
import { USER, type UserStateType, userReducer } from "./user";
import { WORKSPACE, type WorkspaceStateType, workspaceReducer } from "./workspace";

export type StateType = {
	[AI_ASSIST]: AiAssistStateType;
	[CANVAS]: CanvasStateType;
	[CONTROL]: ControlStateType;
	[GRAPHIC]: GraphicStateType;
	[GRAPHIC_PACKAGE]: GraphicPackageStateType;
	[MOS]: MosStateType;
	[OUTPUT]: OutputStateType;
	[PLAYLIST]: PlaylistStateType;
	[BUNDLED_PLAYLIST_GRAPHIC]: BundledPlaylistGraphicStateType;
	[PLAYLIST_GRAPHIC]: PlaylistGraphicStateType;
	[RUNDOWN]: RundownStateType;
	[RUNDOWN_TEMPLATE]: RundownTemplateStateType;
	[USER]: UserStateType;
	[MEDIA_LIBRARY]: MediaLibraryStateType;
	[NOTIFICATION]: NotificationStateType;
	[MATCH_CONTROLS]: MatchControlsStateType;
	[SPORT_DATA]: SportDataStateType;
	[DATA_PROVIDER_TRANSLATION]: DataProviderTranslationStateType;
	[WORKSPACE]: WorkspaceStateType;
	[UI]: UIStateType;
};

export default {
	[AI_ASSIST]: aiAssistReducer,
	[CANVAS]: canvasReducer,
	[CONTROL]: controlReducer,
	[GRAPHIC]: graphicReducer,
	[GRAPHIC_PACKAGE]: graphicPackageReducer,
	[MOS]: mosReducer,
	[OUTPUT]: outputReducer,
	[PLAYLIST]: playlistReducer,
	[BUNDLED_PLAYLIST_GRAPHIC]: bundledPlaylistGraphicReducer,
	[PLAYLIST_GRAPHIC]: playlistGraphicReducer,
	[RUNDOWN]: rundownReducer,
	[RUNDOWN_TEMPLATE]: rundownTemplateReducer,
	[USER]: userReducer,
	[MEDIA_LIBRARY]: mediaLibraryReducer,
	[NOTIFICATION]: notificationReducer,
	[MATCH_CONTROLS]: matchControlsReducer,
	[SPORT_DATA]: sportDataReducer,
	[DATA_PROVIDER_TRANSLATION]: dataProviderTranslationReducer,
	[WORKSPACE]: workspaceReducer,
	[UI]: uiReducer,
};
